import { selectedRoaster } from '$lib/PersistedState.svelte';
import { burnerChartDataStore, roastChartDataStore } from '$lib/Stores';
import type { RoastChartData, TimeTempPair } from '$lib/types/RoastLog';

class ChartData {
  // This is the array of arrays, where each element is a time/temp pair [60, 323.4] for a given
  // thermcocouple or temperature. This is the data that can be handed directly to the chart for
  // plotting.
  //
  // Note that element 0 and 4 are bean temp and heating rate, and thos are always present. The
  // other values are optional and null when those TCs are toggled off. When toggled on, they are
  // arrays of TimeTempPairs like the other arrays.
  // roast: RoastChartData = $state([[], null, null, null, []]);
  roast = <RoastChartData>[[], null, null, null, []];

  // Burner is merely an array of time/temp pairs
  // burner: TimeTempPair[] = $state([]);
  burner = <TimeTempPair[]>[];

  addReadingByIndex(i: number, temp: TimeTempPair) {
    this.roast[i]!.push(temp);
  }

  addHeatingRate(temp: TimeTempPair) {
    this.roast[4]!.push(temp);
  }

  store() {
    roastChartDataStore.set(this.roast);
    burnerChartDataStore.set(this.burner);
  }

  reset(tc2Active: boolean, tc3Active: boolean, tc4Active: boolean) {
    this.roast = [
      [], // Bean, always enabled
      tc2Active ? [] : null,
      tc3Active ? [] : null,
      tc4Active ? [] : null,
      [] // heating rate for bean
    ];
    this.burner = [];
    roastChartDataStore.reset();
    burnerChartDataStore.reset();
  }
}

export default ChartData;
